import { coletarEstadosFormulas } from '@shared/components/formula/utils/formula-estados.util';
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { FormulaEditorDialogComponent, FormulaEditorDialogData, FormulaEditorDialogResult } from '@shared/components/formula/formula-editor-dialog/formula-editor-dialog.component';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';
import { CodigoCreditoPresumidoStruct } from '@shared/services/structs/motor-fiscal/codigo-credito-presumido.struct';
import { getCodigoCreditoPresumidoMeta } from '../../../../codigo-credito-presumido-metadata';

/** Seção de operação do Crédito Presumido: seleção do código da operação. */
@Component({
    selector: 'app-regra-tributaria-credito-presumido-operacao-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule,
        MatTooltipModule,
    ],
    templateUrl: './regra-tributaria-credito-presumido-operacao-section.component.html',
    styleUrl: './regra-tributaria-credito-presumido-operacao-section.component.css',
})
export class RegraTributariaCreditoPresumidoOperacaoSectionComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;
    @Input() formulas: FormulaCatalogoItemStruct[] = [];
    @Input() codigos: CodigoCreditoPresumidoStruct[] = [];

    public get estadosControl(): FormControl {
        return this.form.get('_estadosFormulas') as FormControl;
    }

    constructor(
        private dialog: MatDialog,
        private formulaCatalogoService: FormulaCatalogoService,
    ) {}

    public ngOnInit(): void {
        // Ao trocar o código, liga/desliga os blocos IBS/CBS conforme o metadata local
        // (a coluna `indicadores` do catálogo nunca foi preenchida no banco).
        this.form.get('cCredPres')?.valueChanges.subscribe(cCredPres => {
            const meta = getCodigoCreditoPresumidoMeta(cCredPres);
            if (meta) {
                this.form.get('ibs.isAtivo')?.setValue(meta.ativarIbs);
                this.form.get('cbs.isAtivo')?.setValue(meta.ativarCbs);
            }
        });
    }

    public get personalizadasCount(): number {
        const estados = (this.estadosControl?.value as FormulaItemStruct[]) ?? [];
        return estados.filter(e => e.tipo === TipoFormulaEnum.Personalizada).length;
    }

    public abrirEditorFormulas(): void {
        const data: FormulaEditorDialogData = {
            titulo: 'Crédito Presumido Operação',
            formulas: this.formulas,
            estadosIniciais: (this.estadosControl?.value as FormulaItemStruct[]) ?? [],
            estadosFormulasAgregados: coletarEstadosFormulas(this.form),
            contextoRaiz: 'regra-tributaria',
            validarPersonalizacoes: request => this.formulaCatalogoService.validarPersonalizacoes(request),
        };
        const ref = this.dialog.open(FormulaEditorDialogComponent, { width: '900px', maxWidth: '96vw', maxHeight: '92vh', data });
        ref.afterClosed().subscribe((result: FormulaEditorDialogResult | null) => {
            if (result) {
                this.estadosControl.setValue(result.formulas);
            }
        });
    }
}
